export default __webpack_public_path__ + "ec3eea673101a61b7883b693fc949468.jpg";